export const ACTIONS = {
  ACCESS: 'ACCESS',
  MANAGE: 'MANAGE',
  LAUNCH: 'LAUNCH',
  DELETE: 'DELETE',
  SEARCH: 'SEARCH',
  CREATE: 'CREATE',
} as const;

export type Actions = typeof ACTIONS[keyof typeof ACTIONS];

export const SUBJECTS = {
  ASSESSMENT: 'ASSESSMENT', // Scenarios, Simulations and Atomic Testings
  TEAMS_AND_PLAYERS: 'TEAMS_AND_PLAYERS',
  ASSETS: 'ASSETS',
  PAYLOADS: 'PAYLOADS',
  DASHBOARDS: 'DASHBOARDS',
  FINDINGS: 'FINDINGS',
  DOCUMENTS: 'DOCUMENTS',
  CHANNELS: 'CHANNELS',
  CHALLENGES: 'CHALLENGES',
  LESSONS_LEARNED: 'LESSONS_LEARNED',
  SECURITY_PLATFORMS: 'SECURITY_PLATFORMS',
  PLATFORM_SETTINGS: 'PLATFORM_SETTINGS',
  TENANT_SETTINGS: 'TENANT_SETTINGS',
  RESOURCE: 'RESOURCE',
  TENANTS: 'TENANTS',
  PLATFORM_USERS_GROUPS_AND_ROLES: 'PLATFORM_USERS_GROUPS_AND_ROLES',
} as const;

export type Subjects = typeof SUBJECTS[keyof typeof SUBJECTS];

export const INHERITED_CONTEXT = {
  SCENARIO: 'SCENARIO',
  SIMULATION: 'SIMULATION',
  NONE: 'NONE',
} as const;

export type InheritedContext = typeof INHERITED_CONTEXT[keyof typeof INHERITED_CONTEXT];
